import type { PasteOptionsToolbarPluginConfiguration } from '@atlaskit/editor-plugin-paste-options-toolbar/paste-options-toolbar-plugin-type';

interface Props {
	options: PasteOptionsToolbarPluginConfiguration | undefined;
	usePopupBasedPasteActionsMenuDefault: boolean | undefined;
}

export function pasteOptionsToolbarPluginOptions({
	options,
	usePopupBasedPasteActionsMenuDefault,
}: Props): PasteOptionsToolbarPluginConfiguration {
	return {
		pasteMenuButtonsFactory: options?.pasteMenuButtonsFactory,
		usePopupBasedPasteActionsMenu:
			options?.usePopupBasedPasteActionsMenu ?? usePopupBasedPasteActionsMenuDefault,
	};
}
